import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=0becab56&"
import script from "./Performance.vue?vue&type=script&lang=ts&"
export * from "./Performance.vue?vue&type=script&lang=ts&"
import style0 from "./Performance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0becab56')) {
      api.createRecord('0becab56', component.options)
    } else {
      api.reload('0becab56', component.options)
    }
    module.hot.accept("./Performance.vue?vue&type=template&id=0becab56&", function () {
      api.rerender('0becab56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/performance/Performance.vue"
export default component.exports